import { render, staticRenderFns } from "./PropertyTemplates.vue?vue&type=template&id=7f87694e"
import script from "./PropertyTemplates.vue?vue&type=script&lang=js"
export * from "./PropertyTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports